import type { AdminRepository } from "./admin-repository";

let sample: Promise<AdminRepository> | undefined;

/** The connected helper owns its data; only an offline preview needs a browser sample. */
export function loadDemoRepository(): Promise<AdminRepository> {
  sample ??= import("./demo-repository")
    .then(({ demoRepository }) => {
      demoRepository.loadReviewSample();
      return demoRepository;
    })
    .catch((error: unknown) => {
      sample = undefined;
      throw error;
    });
  return sample;
}
